export function validateBirthYear(year) {
  if (isNaN(Number(year))) return false; // بررسی اینکه سال عدد صحیح باشد
  if (year >= 1300 && year <= 1404) {
    return true; // سال معتبر است
  }
  return false; // سال نامعتبر است
}
